import React from 'react';

//component
import UserConfirmationModal from '../ConfirmationModal';
import ModalWrapper from '../ModalWrapper';

//styling
import "../../../css/global/Modals/remove-passkeys-modal.scss";

const RemovePasskeysModal = ({showModal, hideModal, passkeyName, isLoggedInCredential, onRemovePasskeyClick} : {showModal: boolean, hideModal: () => void, passkeyName: string, isLoggedInCredential?: boolean, onRemovePasskeyClick: () => void}) => {

    if (!showModal){
        return <></>
    }
    return (
        <ModalWrapper 
            isOpen={showModal} 
            onRequestClose={hideModal} 
            className="remove-passkey-modal-wrapper" 
            children={
                <UserConfirmationModal 
                    confirmationModalVariables={{
                        modalTitle: 'Remove Passkey',
                        confirmationQuestion: 
                            isLoggedInCredential
                                ?   "Removing this passkey will log you out of your current session. Are you sure you want to delete this passkey?"
                                :   `Are you sure you want to permanently delete the passkey '${passkeyName}'? This cannot be undone.` ,
                        leftButton: 'Cancel',
                        rightButton: 'Confirm'
                    }} 
                    onLeftButtonClick={hideModal} 
                    onRightButtonClick={onRemovePasskeyClick} 
                    modalClassName={'remove-passkey-modal'} 
                />
            }   
        />
    );  
}

export default RemovePasskeysModal;